function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Path from "./Path";
import PathFilters from "./PathFilters";
import PathItem from "./PathItem";

const NavPath = ({
  className,
  parents,
  filters,
  title,
  onSelect,
  children
}) => {
  const handleSelect = item => {
    item.onClick && item.onClick();
    onSelect && onSelect(item);
  };

  return React.createElement(Path, {
    className: className
  }, parents && parents.map((parent, index) => React.createElement(PathItem, _extends({}, parent, {
    onClick: () => handleSelect(parent),
    key: index
  }), parent.label || parent.title)), filters && React.createElement(PathFilters, {
    filters: filters,
    onSelect: handleSelect
  }), title && React.createElement(PathItem, null, title), children);
};

export default NavPath;